import { useResizeObserver } from "@gemini/core";
import { useCallback, useState } from "react";
export const useThrottledWidthObserver = (
// eslint-disable-next-line no-restricted-globals
ref, callback) => {
    var _a;
    const [contentWidth, setContentWidth] = useState((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.clientWidth);
    const onResize = useCallback(() => {
        var _a;
        if (contentWidth === ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.offsetWidth))
            return;
        const timer = setTimeout(() => {
            var _a;
            setContentWidth((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.offsetWidth);
            callback();
            clearTimeout(timer);
        }, 250);
    }, [ref, contentWidth, callback]);
    useResizeObserver(ref, {
        onResize,
    });
};
